import DocumentTitle from 'react-document-title';
import { Navigate } from 'react-router-dom';

import { toast } from '@hivebrite/design-system/Toast';

import { ApplicationMentee } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Mentee';
import { useMentoringOutletContext } from 'hb-react/frontoffice/apps/Mentoring/container/ProgramControlledAccess';
import PageNotFound from 'hb-react/frontoffice/apps/Mentoring/pages/PageNotFound';
import { getLowerCaseMenteeLabel } from 'hb-react/frontoffice/apps/Mentoring/utils';
import { getApplicationPageTitle } from 'hb-react/frontoffice/apps/Mentoring/utils/applicationUtils';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

interface ApplyToBeMenteeProps {
  disabledAccess?: boolean;
}

export const ApplyToBeMentee = ({ disabledAccess }: ApplyToBeMenteeProps) => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const { program } = useMentoringOutletContext();

  if (
    program &&
    program.mode === 'admin_match' &&
    currentUser?.can_be_a_mentee === false
  ) {
    toast.error(
      s__(
        'Mentoring|Your account does not have the permission to apply as a %{label}. Please contact your admin to receive the relevant rights.',
      ).i__({
        label: getLowerCaseMenteeLabel(program.mentee_label),
      }),
    );

    return <Navigate to="/" />;
  }

  if (
    !program ||
    !currentUser ||
    disabledAccess ||
    program.mode === 'user_match'
  ) {
    return <PageNotFound />;
  }

  return (
    <>
      <DocumentTitle
        title={getApplicationPageTitle({
          label: getLowerCaseMenteeLabel(program.mentee_label),
          currentNetwork,
        })}
      />
      <ApplicationMentee program={program} currentUser={currentUser} />
    </>
  );
};
